module.exports = __webpack_public_path__ + "static/media/masters_thesis14.0477bee4.webp";